exports.PLAYER_LOAD = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYER_LOAD'
exports.PLAYER_PLAY = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYER_PLAY'
exports.PLAYER_PLAYING = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYER_PLAYING'
exports.PLAYER_PAUSE = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYER_PAUSE'
exports.PLAYER_ENDED = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYER_ENDED'
exports.PLAYER_REPLAY = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYER_REPLAY'

exports.PLAYER_BUFFERING = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYER_BUFFERING'
exports.PLAYER_NOT_BUFFERING = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYER_NOT_BUFFERING'

exports.PLAYER_VOLUME_CHANGE = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYER_VOLUME_CHANGE'
exports.PLAYER_SEEK_CHANGE = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYER_SEEK_CHANGE'

exports.TIME_UPDATE = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-TIME_UPDATE'
exports.PLAYBACK_PROGRESS = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYBACK_PROGRESS'
exports.PLAYBACK_PROGRESS_ERROR = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYBACK_PROGRESS_ERROR'
exports.PLAYBACK_VV = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYBACK_VV'
exports.PLAYBACK_VV_ERROR = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYBACK_VV_ERROR'
exports.PLAYBACK_LAGGING = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-PLAYBACK_LAGGING'

exports.DANMU_DISABLE = 'V-STATISTIC-STATISTIC_EVENT-DANMU_DISABLE'
exports.DANMU_SUBMIT = 'V-STATISTIC-STATISTIC_EVENT-DANMU_SUBMIT'
exports.DANMU_TYPE_CHANGE = 'V-STATISTIC-STATISTIC_EVENT-DANMU_TYPE_CHANGE'